import React from 'react';
import { Link } from 'react-router';

const NoPermission = () => {
  return (
    <div className='flex flex-col items-center justify-center min-h-[calc(100vh-200px)] bg-base-200'>
      <h1 className='text-3xl font-bold mb-4'>No Permission</h1>
      <p className='mb-4'>You don't have permission to access this page.</p>
      <Link to='/' className='btn btn-primary'>
        Go Back to Home
      </Link>
    </div>
  );
};

export default NoPermission;
